import { site_url } from 'constant/url'
import { useRouter } from 'next/router'
import React from 'react'

function Cta2() {
  const router = useRouter()
  return (
    <section>
      <div className=" w-full mx-auto   ">
        <div className=" ">
          {/* CTA box */}
          <div
            className="bg-gray-100 rounded py-10 px-8 md:py-16 md:px-8 shadow-2xl"
            data-aos="zoom-y-out"
          >
            <div className="flex flex-col   justify-between items-center">
              {/* CTA content */}
              <div className="mb-6 lg:mr-16  text-center ">
                <h3 className="h3 text-black mb-2">
                  {' '}
                  <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400">
                    DREAMS becomes Reality
                  </span>{' '}
                  when you START
                </h3>
                <p className="text-black text-lg opacity-75">
                  Our pricing is simple and starts with ZERO, you pay only when you make money
                </p>
              </div>

              {/* CTA button */}
              <div>
                <a
                  className="btn custom_gradient_btn text-white px-20"
                  href={'https://community.tradly.app/'}
                  target="_blank"
                >
                  Join Our Community
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Cta2
